import * as THREE from "three";
import { GetSettings } from "./Settings";

exports.Unify = function(unify) {
  this.unify_id = "driveControl";
  const playerCameraRig = new THREE.Object3D();
  playerCameraRig.position.set(0, 0, 0);

  // USER SETTINGS
  const settings = GetSettings();
  let constraints = new THREE.Vector3(settings.playAreaSize / 2, 15, settings.playAreaSize / 2);
  let linearAcceleration = 0.1;
  let linearDrag = 0.05;
  let maxSpeed = new THREE.Vector3(0.05, 0.1, 0.09);
  let speedMultiplier = 1;
  let turnForce = 0.03;
  let turnDrag = 0.03;
  let turnDeadZone = 0.1;
  let turnTimeout = 2;
  let turnMax = 0.015;
  let rollMaxAngle = 10;
  let rollSpeed = 0.75;
  // positional vel
  let velocity = new THREE.Vector3(0, 0, 0);
  let verticalForce = 0.04;
  const gravityForce = 0.05;
  let flying = false;
  let allowFly = false;
  // rotational vel
  let turnInput = new THREE.Vector3();
  let lastTurnInput = new THREE.Vector3();
  let currentTurnVelocity = new THREE.Vector3(0, 0, 0);
  let isTurning = false;
  let turnTarget = 0;
  let tempRot = 0;
  let lastInputTime = 0;
  // raycaster
  let raycaster = new THREE.Raycaster();
  let down = new THREE.Vector3(0, -1, 0);
  let up = new THREE.Vector3(0, 1, 0);
  let avatarOffset = new THREE.Quaternion();
  avatarOffset.setFromAxisAngle(new THREE.Vector3(1, 0, 0), -Math.PI / 2);
  let terrainHeight = 1;
  let terrain = null;
  let intersects = null;
  // avatar
  const avatar = unify.create.cone(unify);
  let normalAngle;
  let swizAngle = new THREE.Vector3();
  // ---------------
  // awake
  this.awake = function() {
    unify.scene.add(playerCameraRig);
    playerCameraRig.add(unify.camera);
    playerCameraRig.name = "player";
    unify.addNewAsset("player", playerCameraRig);
    unify.modules.gameLogic.addEvent_WorldState(setState);

    // temp player avatar
    playerCameraRig.add(avatar);
    avatar.scale.set(0.6, 1.5, 0.2);
    avatar.position.set(0, -1, 0);
    avatar.material = new THREE.MeshNormalMaterial({ color: 0x555555 });
    avatar.rotateX(-1.57);
    unify.camera.position.set(0, 2.5, 10);
    unify.camera.rotateX(-0.25);
  };
  // ---------------
  // start
  this.start = () => {
    terrain = unify.assets.terrain;
    playerCameraRig.position.y = terrain
      ? (playerCameraRig.position.y = unify.modules.terrain.getTerrainHeight(playerCameraRig.position.x, playerCameraRig.position.z) + 2)
      : 0;

    // subscribe to gameLogic
    unify.modules.gameLogic.addEvent_WorldState(setState);
  };

  // check input
  function checkAccelKeys() {
    let inVel = new THREE.Vector3();
    if (unify.input.keyIsPressed("w")) {
      inVel.z = -1;
    }
    if (unify.input.keyIsPressed("s")) {
      inVel.z = 1;
    }
    if (unify.input.keyIsPressed(" ")) {
      inVel.y = 1;
    }
    if (unify.input.keyIsPressed("a")) {
      inVel.x = -1;
    }
    if (unify.input.keyIsPressed("d")) {
      inVel.x = 1;
    }
    return inVel;
  }

  function checkTurnInput() {
    if (isTurning) lastTurnInput.copy(turnInput);

    // mouse position as turn input
    turnInput.y = THREE.Math.clamp(unify.input.getMousePosition().x, -1, 1) * -1;
    if (Math.abs(turnInput.y) < turnDeadZone) turnInput.y = 0;

    // timeout check
    if (turnInput.y != lastTurnInput.y) {
      lastInputTime = unify.engine.getTimeSinceStart();
      isTurning = true;
    } else {
      if (unify.engine.getTimeSinceStart() - lastInputTime >= turnTimeout) {
        turnInput.set(0, 0, 0);
        isTurning = false;
      }
    }
    return turnInput;
  }

  // ---------------
  // update
  this.update = deltaTime => {
    // linear acceleration
    let linearInput = checkAccelKeys();
    if (linearInput.x != 0) {
      // accelerate X
      velocity.x += linearInput.x * linearAcceleration * deltaTime;
      velocity.x = unify.utilities.clamp(velocity.x, -maxSpeed.x, maxSpeed.x);
    } else {
      // drag X
      if (Math.abs(velocity.x) > linearDrag * deltaTime)
        velocity.x = velocity.x > 0 ? velocity.x - linearDrag * deltaTime : velocity.x + linearDrag * deltaTime;
      else velocity.x *= 0.01;
    }
    if (linearInput.z != 0) {
      // accerlerate Z
      velocity.z += linearInput.z * linearAcceleration * deltaTime;
      velocity.z = unify.utilities.clamp(velocity.z, -maxSpeed.z, maxSpeed.z);
    } else {
      // drag Z
      if (Math.abs(velocity.z) > linearDrag * deltaTime)
        velocity.z = velocity.z > 0 ? velocity.z - linearDrag * deltaTime : velocity.z + linearDrag * deltaTime;
      else velocity.z *= 0.01;
    }

    // rotation
    let turnInput = checkTurnInput();
    if (turnInput.x != 0 || turnInput.y != 0 || turnInput.z != 0) {
      currentTurnVelocity.y += turnForce * turnInput.y * deltaTime;
      currentTurnVelocity.y = unify.utilities.clamp(currentTurnVelocity.y, -turnMax, turnMax);
    } else {
      if (Math.abs(currentTurnVelocity.y) > linearDrag * deltaTime)
        currentTurnVelocity.y = currentTurnVelocity.y > 0 ? currentTurnVelocity.y - turnDrag * deltaTime : currentTurnVelocity.y + turnDrag * deltaTime;
      else currentTurnVelocity.y *= 0.01;
    }

    // // Y axis
    raycaster.set(playerCameraRig.position, down);
    if (terrain) {
      intersects = raycaster.intersectObject(terrain, false);
      if (intersects != null && intersects[0] != null) {
        terrainHeight = intersects[0].point.y + 2;
        normalAngle = intersects[0].face.normal;
      } else terrainHeight = unify.modules.terrain.getTerrainHeight(playerCameraRig.position.x, playerCameraRig.position.z) + 2;
    } else {
      terrainHeight = 0;
    }

    // clamp terrain min Y position
    if (playerCameraRig.position.y <= terrainHeight) {
      flying = false; // no longer falling, go back to glide mode
      playerCameraRig.position.y = terrainHeight;
      velocity.y = 0;
    }

    if (playerCameraRig.position.y >= constraints.y) velocity.y = 0;

    // apply y input, gravity
    if (playerCameraRig.position.y >= terrainHeight) {
      if (linearInput.y != 0 && allowFly) {
        velocity.y += linearInput.y * deltaTime * verticalForce; // apply Y input
        flying = true;
      } else {
        if (flying) {
          velocity.y -= gravityForce * deltaTime; // falling, apply gravity
        } else playerCameraRig.position.y = terrainHeight; // glide precisely over terrain
      }
    } else {
      velocity.y = velocity.y < 0 ? 0 : velocity.y;
    }
    velocity.y = THREE.Math.clamp(velocity.y, -maxSpeed.y, maxSpeed.y);

    // apply new rotation
    let rot = playerCameraRig.rotation;
    rot.y += currentTurnVelocity.y;

    // calculate roll for flavor (Z axis)
    if (isTurning) {
      turnTarget = turnInput.y * -rollSpeed * Math.abs(velocity.z * rollMaxAngle);
    } else {
      turnTarget = 0;
    }

    // rotation calculation helper
    let dif = tempRot - turnTarget;
    if (tempRot > turnTarget) tempRot -= deltaTime * dif; // reduce
    if (tempRot < turnTarget) tempRot += deltaTime * -dif; // increase
    avatar.rotation.set(-1.57, tempRot * 2, 0);
    avatar.rotateOnWorldAxis(up, -tempRot);
    //avatar.quaternion.copy(avatarOffset);

    //swizAngle.set(normalAngle.y, normalAngle.z, normalAngle.x);
    //avatar.quaternion.setFromUnitVectors(up, normalAngle.clone().multiplyScalar(0.5));

    playerCameraRig.rotation.copy(rot);

    // apply new position
    playerCameraRig.translateZ(velocity.z * speedMultiplier);
    playerCameraRig.translateX(velocity.x * speedMultiplier);
    playerCameraRig.position.y += velocity.y * speedMultiplier;

    // constraints
    playerCameraRig.position.y = THREE.Math.clamp(playerCameraRig.position.y, terrainHeight - 2, constraints.y);
    playerCameraRig.position.z = THREE.Math.clamp(playerCameraRig.position.z, -constraints.z, constraints.z);
    playerCameraRig.position.x = THREE.Math.clamp(playerCameraRig.position.x, -constraints.x, constraints.x);
  };

  const setState = state => {
    switch (state) {
      case -1:
        break;
      case 0:
        speedMultiplier = 1;
        allowFly = false;
        break;
      case 1:
        speedMultiplier = 2;
        allowFly = true;
        break;
      case 2:
        speedMultiplier = 1;
        allowFly = false;
        break;
    }
  };
};
